import {
  NgModule,
} from "@angular/core";
import { LOCALE_ID } from '@angular/core';
import localePt from '@angular/common/locales/pt';
import { CommonModule, DatePipe } from "@angular/common";
import { RouterLink, RouterModule, Routes } from "@angular/router";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { SystemViewLayoutSelectorComponent } from "./system-view-layout-selector.component";
import { NavService } from "../services/nav.service";
import { ProdutosComponent } from "../forms/produtos/produtos.component";
import { ClientesComponent } from "../forms/clientes/clientes.component";
import { MercadolivreComponent } from "../forms/produtos/mercadolivre/mercadolivre.component";
import { GridviewComponent } from "../forms/gridview/gridview.component";
import { CardviewComponent } from "../forms/gridview/cardview/cardview.component";
import { AmazonComponent } from "../forms/produtos/amazon/amazon.component";
import { FilterviewComponent } from "../forms/gridview/filterview/filterview.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DynamicFormsModule } from "../dynamic-forms/dynamic-forms.module";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { UserAuthenticationServices } from "../services/user-authentication.services";
import { MenuServices } from "../services/menu-service.services";
import { UserConfigServices } from "../services/user-config.services";
import { SalvarfiltroComponent } from "../forms/gridview/salvarfiltro/salvarfiltro.component";
import { SnackbarService } from "../services/snackbar.service";
import { FormServices } from "../services/form.services";
import { GridsterModule } from "angular-gridster2";
import localeBr from "@angular/common/locales/pt";
import localeBrExtra from "@angular/common/locales/extra/pt";
import { registerLocaleData } from "@angular/common";
import { Capitalize } from "../system-utils/pipes/capitalize";
import { CriacaoProdutoComponent } from "../forms/produtos/amazon/criacao-produto/criacao-produto.component";
import { CriacaoProdutoFormComponent } from "../forms/produtos/amazon/criacao-produto/criacao-produto-form/criacao-produto-form.component";
import { DateOnlyPipe } from "../services/DateOnlyPipe";
import { UserFormConfigComponent } from "../forms/usuarios/user-form-config/user-form-config.component";
import { ImageComponent } from "../system-utils/utils/components/image-component";
import { LazyLoadImageModule } from "ng-lazyload-image";
import { ThemeService } from "../services/theme.service";
import { LogAplicacaoComponent } from "../forms/log-aplicacao/log-aplicacao.component";
import { NumberDirective } from "../system-utils/utils/directives/numbers-only.directive";
import { MainDashboardModule } from "./main-dashboard/main-dashboard.module";
import { PushPedidosComponent } from "../forms/push-pedidos/push-pedidos.component";
import { PushPedidosStepperComponent } from "../forms/push-pedidos/push-pedidos-stepper/push-pedidos-stepper.component";

import { PromptSaveDialogComponent } from "../system-utils/prompt-save-dialog/prompt-save-dialog.component";
import { FormulaTesterComponent } from "../forms/formula-tester/formula-tester.component";
import { CryptoServices } from "../services/CryptoServices";
import { InterceptorHttp } from "../services/interceptor.http";
import { OrdersViewComponent } from "../forms/orders-view/orders-view.component";
import { ResizeColumnDirective } from "../system-utils/utils/directives/resize-columns.directive";
import { ResizableModule } from "angular-resizable-element";
import { SimpleFilterViewComponent } from "../forms/simple-filter-view/simple-filter-view.component";
import { InputButtonPopupComponent } from "../system-utils/input-button-popup/input-button-popup.component";
import { InputAutocompleteComponent } from "../system-utils/input-autocomplete/input-autocomplete.component";
import { CronFormComponent } from "../forms/cron-form/cron-form.component";
import { CronEditorModule } from "../cron-editor-module/cron-editor-module.module";
import { NotificationsCardComponent } from "../system-utils/notifications-card/notifications-card.component";
import { dateFormatPipe } from "../system-utils/pipes/datetransform";
import { StatusViewComponent } from "../forms/status-view/status-view.component";
import { NewProductAmazonComponent } from "../forms/produtos/amazon/new-product-amazon/new-product-amazon.component";
import { IvyCarouselModule } from "carousel-angular";
import { JsonFormsPopupComponent } from "../system-utils/json-forms-popup/json-forms-popup.component";
import { SystemComponent } from "../forms/system/system.component";
import { RefreshPreferencesServices } from "../services/RefreshPreferences.service";
import { MeliEditFormComponent } from "../forms/produtos/mercadolivre/meli-edit-form/meli-edit-form.component";
import { MeliMlbDownloadComponent } from "../forms/produtos/mercadolivre/meli-mlb-download/meli-mlb-download.component";
import { MeliCategoryFinderComponent } from "../forms/produtos/mercadolivre/meli-category-finder/meli-category-finder.component";
import { MeliItemComponent } from "../forms/produtos/mercadolivre/meli-item/meli-item.component";
import { MeliAttributesComponent } from "../forms/produtos/mercadolivre/meli-item/meli-attributes/meli-attributes.component";
import { MeliVariationComponent } from "../forms/produtos/mercadolivre/meli-item/meli-variation/meli-variation.component";
import { MeliProductRelationComponent } from "../forms/produtos/mercadolivre/meli-item/meli-product-relation/meli-product-relation.component";
import { VariationMeliPopupComponent } from "../forms/produtos/mercadolivre/meli-item/variation-meli-popup/variation-meli-popup.component";
import { FromToFormComponent } from "../forms/from-to-form/from-to-form.component";
import { BreadcrumbComponent } from "../system-utils/breadcrumb/breadcrumb.component";
import { CdkStepperModule } from "@angular/cdk/stepper";
import { MeliCategoryPredictorComponent } from "../forms/produtos/mercadolivre/meli-edit-form/meli-category-predictor/meli-category-predictor.component";
import { CustomValidatorDirectiveDirective } from "../system-utils/utils/directives/custom-validator-directive.directive";
import { ExternalAuthenticationComponent } from "../forms/authentication/authentication.component";
import { OAuthModule } from "angular-oauth2-oidc";
import { SkuViewComponent } from "../forms/sku-view/sku-view.component";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { FieldsDataSelectComponent } from "../forms/produtos/mercadolivre/meli-edit-form/fields-data-select/fields-data-select.component";
import { ProdutoKitComponent } from "../forms/produtos/produto-kit/produto-kit.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { MeliServices } from "../services/meli.service";
import {
  CustomTreeService,
  CustomTreeViewComponent,
} from "../system-utils/custom-tree-view/custom-tree-view.component";
import { KtdGridModule } from "@katoid/angular-grid-layout";
import { NgxEditorModule } from 'ngx-editor';
import { MeliTaskProcessorComponent } from "../forms/produtos/mercadolivre/meli-mlb-download/meli-task-processor/meli-task-processor.component";
import { RoundedCheckboxComponent } from "../system-utils/rounded-checkbox/rounded-checkbox.component";
import { IntegracaoMelhorEnvioComponent } from "../forms/transportadoras/integracao-melhor-envio/integracao-melhor-envio.component";
import { ChangePasswordFormComponent } from "../system-utils/change-password-form/change-password-form.component";
import { AnunciosComponent } from "../forms/anuncios/anuncios.component";
import { ImportacaoDadosComponent } from "../forms/importacao-dados/importacao-dados.component";
import { ShopeeComponent } from "../forms/produtos/shopee/shopee.component";
import { TaskProcessorComponent } from "../system-utils/task-processor/task-processor.component";
import { AcessViewComponent } from "../forms/acess-view/acess-view.component";
import { MenuViewComponent } from "../forms/acess-view/menu-view/menu-view.component";
import { InstancesActionViewComponent } from "../forms/acess-view/instances-action-view/instances-action-view.component";
import { CompaniesViewComponent } from "../forms/acess-view/companies-view/companies-view.component";
import { CopyAcessPopupComponent } from "../forms/acess-view/copy-acess-popup/copy-acess-popup.component";
import { IntegrationServices } from "../services/integration.services";
import { TutorialServices } from "../services/tutorial.services";
import { SimpleFormComponent } from "../forms/simple-form/simple-form.component";
import {
  ActionButtonGenericComponent,
  VALIDATION,
} from "../system-utils/action-button-generic/action-button-generic.component";

import { FormViewActionComponent } from "../dynamic-forms/form-view/form-view-action/form-view-action.component";
import { ShopeeCategoryComponent } from "../forms/produtos/shopee/shopee-category/shopee-category.component";
import { ProductsDownloadComponent } from "../forms/products-download/products-download.component";
import { ProductsDownloadTaskProcessorComponent } from "../forms/products-download/products-download-task-processor/products-download-task-processor.component";
import { ShopeeAttributeComponent } from "../forms/produtos/shopee/shopee-attribute/shopee-attribute.component";
import { ShopeeServices } from "../services/shopee.service";
import { MatCarouselModule } from "../system-utils/carousel/carousel.module";
import { OverlayModule } from "@angular/cdk/overlay";
import { ShopeeVarTierComponent } from "../forms/produtos/shopee/shopee-var-tier/shopee-var-tier.component";
import { BehaviorSubject } from "rxjs";
import { TempFormComponent } from "../system-utils/temp-form/temp-form.component";
import { CatalogoComponent } from "../forms/produtos/mercadolivre/catalogo/catalogo.component";
import { PainelCorreiosComponent } from "../forms/painel-correios/painel-correios.component";
import { CepDisponibilidadeComponent } from "../forms/painel-correios/cep-disponibilidade/cep-disponibilidade.component";
import { CepRangeComponent } from "../forms/painel-correios/cep-range/cep-range.component";
import { CepTrackingComponent } from "../forms/painel-correios/cep-tracking/cep-tracking.component";
import { CepBuscaobjetoComponent } from "../forms/painel-correios/cep-buscaobjeto/cep-buscaobjeto.component";
import { CorreiosServices } from "../services/correios.services";
import { NgxMaskModule } from "ngx-mask";
import { CepConsultaprecoComponent } from "../forms/painel-correios/cep-consultapreco/cep-consultapreco.component";
import { PromptSaveDialogComponentMultiple } from "../system-utils/prompt-save-dialog-multiple/prompt-save-dialog-multiple.component";
import { MarketPlaceTabsComponent } from "../forms/market-place-tabs/market-place-tabs.component";
import { ViaVarejoCategoryComponent } from "../forms/produtos/viavarejo/viavarejo-category/viavarejo-category.component";
import { ViaVarejoAttributeComponent } from "../forms/produtos/viavarejo/viavarejo-attribute/viavarejo-attribute.component";
import { FilterLength } from "../system-utils/pipes/filter-length";
import { CarrefourCategoryComponent } from "../forms/produtos/carrefour/carrefour-category/carrefour-category.component";
import { DictionaryActionsComponent } from "../forms/dictionary-action/dic-action.component";
import { MeliNewWizardComponent } from '../forms/produtos/meli/meli-new-wizard/meli-new-wizard.component';
import { ItemMeliCatalogoCardComponent } from '../forms/produtos/meli/meli-new-wizard/item-meli-catalogo-card/item-meli-catalogo-card.component';
import { MeliEditFormMultiTableComponent } from '../forms/produtos/mercadolivre/meli-edit-form-multi-table/meli-edit-form-multi-table.component';
import { dateFormatPipe2 } from "../system-utils/pipes/datetransform2";
import { ProdutoInsertEditFormComponent } from '../forms/produtos/produto-insert-edit-form/produto-insert-edit-form.component';
import { PaymentsComponent } from "../forms/payments/payments.component";

import { FormulaTesterActionComponent } from '../forms/formula-tester/formula-tester-action/formula-tester-action.component';
import { GenericTabComponent } from "../forms/market-place-tabs/generic-tab/generic-tab.component";
import { PostChipDdComponent } from '../system-utils/post-chip-dd/post-chip-dd.component';
import { DictionaryFormComponent } from "../forms/dictionary-form/dictionary-form.component";
import { FormEditComplexComponent } from '../forms/formview/form-edit-complex/form-edit-complex.component';
import { MeliItemVariationAttribComponent } from "../forms/produtos/mercadolivre/meli-item-variation-attrib/meli-item-variation-attrib.component";
import { MeliItemGarantiaComponent } from "../forms/produtos/mercadolivre/meli-item-garantia/meli-item-garantia.component";
import { MeliItemAttribComponent } from "../forms/produtos/mercadolivre/meli-item-attrib/meli-item-attrib.component";
import { MeliItemVariationComponent } from "../forms/produtos/mercadolivre/meli-item-variation/meli-item-variation.component";
import { PermissionServices } from "../services/permission.services";
import { AmazonSchemaCreatorComponent } from '../forms/produtos/amazon/amazon-schema-creator/amazon-schema-creator.component';
import { GridColorConfigurationComponent } from "../forms/simple-datagrid/grid-color-configuration/grid-color-configuration.component";
import { ShopeeVarNewComponent } from "../forms/produtos/shopee/shopee-var-new/shopee-var-new.component";
import { ShopeeVarComponent } from "../forms/produtos/shopee/shopee-var/shopee-var.component";
import { FormulaServices } from "../services/formula.service";
import { JsonConfigComponent } from "../forms/importacao-dados/json-config/json-config.component";
import { DPARAModalComponent } from "../forms/importacao-dados/d-para-component/dparamodal/dparamodal.component";
import { FlowModalComponent } from "../forms/flow-action/flowaction.component";
import { TabService } from "../services/tab.service";
import { OptionDialogComponent } from '../system-utils/option-dialog/option-dialog.component';
import { TooltipComponent } from "../system-utils/tooltip/tooltip.component";
import { InstanceGenericViewComponent } from "../forms/instance-generic-view/instance-generic-view.component";
import { ImageSelectorComponent } from "../forms/image-selector/image-selector.component";
import { AmazonSearchCategoryComponent } from '../forms/produtos/amazon/amazon-search-category/amazon-search-category.component';
import { AmazonErrorMessageComponent } from '../forms/produtos/amazon/amazon-error-message/amazon-error-message.component';
import { LiveloSearchCategoryComponent } from "../forms/produtos/livelo/livelo-category/livelo-category.component";
import { ContractprefMainComponent } from '../forms/contractpref-main/contractpref-main.component';
import { ModuleRegistry } from '@ag-grid-community/core';
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { AgGridModule } from "@ag-grid-community/angular"
import {ClientSideRowModelModule} from "@ag-grid-community/client-side-row-model";

import {TreeviewModule} from '@soy-andrey-semyonov/ngx-treeview';
import { SharedModule } from "../shared-module/shared-module.module";
import { MenuCreatorComponent } from "../forms/menu-creator/menu-creator.component";
import { EditDataGridComponent } from "../system-utils/edit-data-grid/edit-data-grid.component";
import { ScreenRecorderModule } from "../screen-recorder/screen-recorder.module";
import { WebhookCreatorModule } from "../webhook-creator/webhook-creator.module";
import { LogIntegracaoItemComponent } from "../system-utils/log-integracao-item/log-integracao-item.component";
import { AdminServices } from "../services/AdminServices";
import { WebScrapingComponent } from "../web-scraping/web-scraping.component";
import { EventRecorderService } from "../services/WebScrapingRecorder.service";
import { B2wAttributeComponent } from "../forms/produtos/b2w/b2w-attribute/b2w-attribute.component";
import { B2wCategoryComponent } from "../forms/produtos/b2w/b2w-category/b2w-category.component";
import { B2wAttributeVarComponent } from "../forms/produtos/b2w/b2w-attribute/b2w-attribute-var.component";
import { DynamicLoaderService } from "../services/dynamic-loader.service";
import { ConfigJsonComponent } from "../forms/json-component/config-json/config-json.component";
import { AppJsonConfigComponent } from "../forms/json-component/app-json-config/app-json-config.component";
import { RequestConfigComponent } from "../forms/json-component/request-config/request-config/request-config.component";
import { JsonImporterComponent } from "../forms/json-importer/json-importer.component";
import { BuilderScreenBetaModule } from "../builder-screen-beta/builder-screen.module";
import { TiktokAttributeComponent } from "../forms/produtos/tiktok/tiktok-attribute/tiktok-attribute.component";
import { TiktokCategoryComponent } from "../forms/produtos/tiktok/tiktok-category/tiktok-category.component";
import { TiktokAttributeVarComponent } from "../forms/produtos/tiktok/tiktok-attribute/tiktok-attribute-var.component";
import { TiktokBrandComponent } from "../forms/produtos/tiktok/tiktok-brand/tiktok-brand.component";
import { GenericLogComponent, GridButtonRendererComponent } from "../forms/generic-log/generic-log.component";
import { GenericLogSearchPipe } from "../forms/generic-log/generic-log-search.pipe";
 import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import { FormulaLabComponent } from "../forms/formula-lab/formula-lab.component";
import { NzAlertModule } from "ng-zorro-antd/alert";
import { NzUploadModule } from "ng-zorro-antd/upload";
import { NzEmptyModule } from "ng-zorro-antd/empty";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzCardModule } from "ng-zorro-antd/card";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzProgressModule } from "ng-zorro-antd/progress";
import { NZ_ICONS, NZ_ICONS_PATCH, NzIconModule } from "ng-zorro-antd/icon";
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { NzTagModule } from "ng-zorro-antd/tag";
// Balao de chamados: mora no shell autenticado, e nao no modulo lazy de
// Chamados — se morasse la, so apareceria para quem ja esta na tela de
// chamados, que e exatamente quem nao precisa dele.
import { ChamadosWidgetComponent } from "../chamados/widget/chamados-widget.component";
import { NzAvatarModule } from "ng-zorro-antd/avatar";
import { NzListModule } from "ng-zorro-antd/list";
import { NzAutocompleteModule } from "ng-zorro-antd/auto-complete";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzStepsModule } from "ng-zorro-antd/steps";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { SystemViewNewComponent } from "./system-view-new/system-view-new.component";
import { SystemViewNewItemComponent } from "./system-view-new/system-view-new-item/system-view-new-item.component";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { ShopeeAttributeFieldComponent } from "../forms/produtos/shopee/shopee-attribute/shopee-attribute-field/shopee-attribute-field.component";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzTreeModule } from "ng-zorro-antd/tree";


ModuleRegistry.registerModules([
  CsvExportModule,
  ClientSideRowModelModule,
  InfiniteRowModelModule 
]);


registerLocaleData(localeBr, localeBrExtra);
registerLocaleData(localePt, 'br');

const appRoutes: Routes = [];

@NgModule({ 
  declarations: [
        ChamadosWidgetComponent,
        ConfigJsonComponent,    
        JsonImporterComponent,
        RequestConfigComponent,
        AppJsonConfigComponent,        
        DPARAModalComponent,
        FlowModalComponent,
        JsonConfigComponent,
        ProdutosComponent,
        DateOnlyPipe,
        UserFormConfigComponent,
        LogAplicacaoComponent,
        FilterLength,
        dateFormatPipe,
        dateFormatPipe2,
        JsonFormsPopupComponent,
        StatusViewComponent,
        ClientesComponent,
        AmazonComponent,
        NewProductAmazonComponent,
        MercadolivreComponent,
        GridviewComponent,
        CardviewComponent,
        FilterviewComponent,
        PromptSaveDialogComponentMultiple,
        SalvarfiltroComponent,
        CriacaoProdutoComponent,
        CriacaoProdutoFormComponent,
        ImageComponent,
        NumberDirective,
        PushPedidosComponent,
        PushPedidosStepperComponent,
        WebScrapingComponent,
        PromptSaveDialogComponent,
        FormulaTesterComponent,
        OrdersViewComponent,
        ResizeColumnDirective,
        SimpleFilterViewComponent,
        InputAutocompleteComponent,
        InputButtonPopupComponent,
        CronFormComponent,
        NotificationsCardComponent,
        SystemComponent,
        MeliEditFormComponent,
        MeliMlbDownloadComponent,
        MeliCategoryFinderComponent,
        MeliItemVariationComponent,
        MeliItemComponent,
        DictionaryActionsComponent,
        MeliVariationComponent,
        MeliAttributesComponent,
        MeliProductRelationComponent,
        VariationMeliPopupComponent,
        FromToFormComponent,
        BreadcrumbComponent,
        MeliCategoryPredictorComponent,
        CustomValidatorDirectiveDirective,
        ExternalAuthenticationComponent,
        SkuViewComponent,
        FieldsDataSelectComponent,
        ProdutoKitComponent,
        CustomTreeViewComponent,
        MeliTaskProcessorComponent,
        RoundedCheckboxComponent,
        IntegracaoMelhorEnvioComponent,
        ChangePasswordFormComponent,
        AnunciosComponent,
        ImportacaoDadosComponent,
        ShopeeComponent,
        TaskProcessorComponent,
        AcessViewComponent,
        MenuViewComponent,
        InstancesActionViewComponent,
        CompaniesViewComponent,
        CopyAcessPopupComponent,
        FormViewActionComponent,
        ShopeeCategoryComponent,
        ProductsDownloadComponent,
        ProductsDownloadTaskProcessorComponent,
        ShopeeAttributeComponent,
        ShopeeAttributeFieldComponent,
        ShopeeVarComponent,
        ShopeeVarTierComponent,
        ActionButtonGenericComponent,
        TempFormComponent,
        CatalogoComponent,
        PainelCorreiosComponent,
        CepDisponibilidadeComponent,
        CepRangeComponent,
        CepTrackingComponent,
        CepBuscaobjetoComponent,
        CepConsultaprecoComponent,
        AcessViewComponent,
        MenuViewComponent,
        InstancesActionViewComponent,
        CompaniesViewComponent,
        CopyAcessPopupComponent,
        SimpleFormComponent,                
        FormViewActionComponent,
        ShopeeCategoryComponent,
        ProductsDownloadComponent,
        ProductsDownloadTaskProcessorComponent,
        ShopeeAttributeComponent,
        ShopeeVarComponent,
        ShopeeVarTierComponent,
        ActionButtonGenericComponent,
        TempFormComponent,
        MarketPlaceTabsComponent,
        ViaVarejoCategoryComponent,
        ViaVarejoAttributeComponent,
        CarrefourCategoryComponent,
        MeliNewWizardComponent,
        ItemMeliCatalogoCardComponent,
        MeliEditFormMultiTableComponent,
        ProdutoInsertEditFormComponent,
        PaymentsComponent,
        FormulaTesterActionComponent,
        GenericTabComponent,
        PostChipDdComponent,
        DictionaryFormComponent,
        FormEditComplexComponent,
        MeliItemVariationAttribComponent,
        MeliItemGarantiaComponent,
        MeliItemAttribComponent,
        AmazonSchemaCreatorComponent,        
        GridColorConfigurationComponent,
        ShopeeVarNewComponent,
        OptionDialogComponent,
        TooltipComponent,
        InstanceGenericViewComponent,
        ImageSelectorComponent,
        AmazonSearchCategoryComponent,
        AmazonErrorMessageComponent,
        LiveloSearchCategoryComponent,
        ContractprefMainComponent,
        MenuCreatorComponent,
        EditDataGridComponent,
        LogIntegracaoItemComponent,
        B2wAttributeComponent,
        B2wAttributeVarComponent,
        B2wCategoryComponent,
        TiktokAttributeComponent,
        TiktokAttributeVarComponent,
        TiktokCategoryComponent,
        TiktokBrandComponent,
        SystemViewNewComponent,
        SystemViewNewItemComponent,
        SystemViewLayoutSelectorComponent,
        FormulaLabComponent,
    ],
    exports: [DateOnlyPipe, FilterLength],
    imports: [AgGridModule,
        ClipboardModule,
        CommonModule,
        /*RouterModule.forRoot(appRoutes, {
          useHash: true,
          relativeLinkResolution: "legacy",
        }),*/
        RouterModule.forChild(appRoutes),
        ReactiveFormsModule,
        FormsModule,
        DynamicFormsModule,
        DragDropModule,
        GridsterModule,
        // O BrowserAnimationsModule NAO entra em modulo de funcionalidade: ele
        // importa o BrowserModule por dentro, e cai no mesmo NG05100 quando um
        // componente standalone que importe este modulo instancia os providers
        // num injetor proprio. As animacoes ja vem do AppModule.
        TreeviewModule.forRoot(),
        MainDashboardModule,
        ResizableModule,
        CronEditorModule,
        IvyCarouselModule,
        CdkStepperModule,
        ScrollingModule,
        OAuthModule.forRoot(),
        NgxDatatableModule,
        FontAwesomeModule,
        KtdGridModule,
        LazyLoadImageModule,
        MatCarouselModule.forRoot(),
        OverlayModule,
        NgxMaskModule.forRoot(),
        NgxEditorModule,
        FontAwesomeModule,
        SharedModule,
        ScreenRecorderModule,
        WebhookCreatorModule,        
        BuilderScreenBetaModule,
        NzSpinModule,
        NzUploadModule,
        NzCardModule,
        NzFormModule,
        NzInputModule,
        NzSelectModule,
        NzButtonModule,
        NzProgressModule,
        NzIconModule,
        NzDividerModule,
        NzGridModule,
        NzModalModule,
        NzCollapseModule,
        NzTagModule,
        NzAvatarModule,
        NzListModule,
        NzAutocompleteModule,
        NzSwitchModule,
        NzStepsModule,
        NzTableModule,
        NzToolTipModule,
        NzDropDownModule,
        NzMenuModule,
        NzLayoutModule,
        NzTabsModule,
        NzMenuModule,
        NzAlertModule,
        NzEmptyModule,
        NzCheckboxModule,
        RouterLink,
        NzDatePickerModule,
        NzBadgeModule,
        NzRadioModule,
        NzTreeModule

       ],
  providers: [
        MenuServices,
        TabService,
        NavService,
        UserConfigServices,
        UserAuthenticationServices,
        SnackbarService,
        FormServices,
        DatePipe,
        Capitalize,
        ThemeService,
        DynamicLoaderService,
        CryptoServices,
        AdminServices,
        InterceptorHttp,
        RefreshPreferencesServices,
        MeliServices,
        CorreiosServices,
        ShopeeServices,
        IntegrationServices,
        CustomTreeService,
        TutorialServices,
        FormulaServices,
        PermissionServices,
        EventRecorderService,
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorHttp,
            multi: true,
        },
        {
            provide: VALIDATION,
            useValue: new BehaviorSubject<String>(""),
        },
        /*{
              provide: HTTP_INTERCEPTORS,
              useClass: LoadingInterceptor,
              multi: true
            },*/
        Capitalize
    ] })
export class SystemViewModule {}
